import { render } from "./SurveyQuestionTextarea.vue?vue&type=template&id=44ae2bf2&scoped=true"
import script from "./SurveyQuestionTextarea.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionTextarea.vue?vue&type=script&lang=js"

import "./SurveyQuestionTextarea.vue?vue&type=style&index=0&id=44ae2bf2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44ae2bf2"

export default script